import { ICON__square_solid } from '@/assets/icons_fa';
import NotifierBorder from '@/components/ui/notifier/notifier-border';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { ENUM__component_type } from '@/enums/ENUM__component_type';
import { ViewShortcutTrigger } from '@/pages/_base/shortcut_hint/ViewShortcutTrigger';
import { HOOK_GENERATION__notifier } from '@/pages/page_generation/view_header/_buttons/button_generation/_hooks/HOOK_GENERATION__notifier';
import { HOOK_GENERATION__stop } from '@/pages/page_generation/view_header/_buttons/button_generation/_hooks/HOOK_GENERATION__stop';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { EShortcutType } from '@shared/dto/hint_shortcuts/e_shortcut_type';
import { useTranslation } from 'react-i18next';

export function G_BUTTON__generation_stop() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_GENERATION);

  const { notifier } = HOOK_GENERATION__notifier(ENUM__component_type.PAGE_GENERATION_BUTTON_GENERATION_STOP);

  let { generation_stop, can_stop_generation } = HOOK_GENERATION__stop();

  /*
   * HTML
   */
  return (
    <ViewShortcutTrigger hint_shortcut_keys={[EShortcutType.GENERATION_STOP]}>
      <UI_PRIMITIVE__button variant="no-border-on-bar" onClick={() => generation_stop(false)} size="full" disabled={!can_stop_generation}>
        <NotifierBorder {...{ notifier }} />
        <ICON__square_solid className="!size-5 !text-red-700" />
      </UI_PRIMITIVE__button>
    </ViewShortcutTrigger>
  );
}
